module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABB0lEQVQ4T52RvU3FQBCEdzASIT8ZuAQX8CQyZO8GUMCjAiqAKqALAmgAhG6NTUwBBBRAhIQgxPYtOkv3xEOH+dl05xvN7IL+OUhxbduu9n3/QERbZjYXkduvuiXQzFZUdQgiAHsAnrz3d0S0DeCMmU+iwQKMkIgkUzjnDMA1Mx+MxtEhLL6DUpoRDJ26rut+ApummQ3DcMPMmyOoqo9EdMTMoc/kxGQRfAawW1VVMPg96JwriehcRHamKDODqvpQ6c/HyfN8rSiK9wWoqqdmdjzxjgsiOoz7pZ+p6pWZ7WdZNivL8j7EjvE+VXgTkfXks1X1xcw2ojjGq+t67r2/BPCaBKcOFOEP47mQXf3c7KsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-index-search.png
// module id = 198
// module chunks = 0